import { StateUtils } from '@spartacus/core';
import { EntriesState, PagesState } from '../../../../../core/features/store/base-feature-state';
import { News, NewsPage } from '../model';

export const NEWS_FEATURE = 'news';

export const NEWS = '[News] News';

export interface StateWithNews {
  [NEWS_FEATURE]: NewsState;
}

export interface NewsState {
  pages: PagesState<StateUtils.LoaderState<NewsPage>>;
  entities: EntriesState<News>;
}
